import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FirestoreService } from "../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../shared/api/firebase/references";
import { AppDispatch } from "../store/store";

interface MedicalPaCoverageState {
  medicalPaCoveragerawResponse: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: MedicalPaCoverageState = {
  medicalPaCoveragerawResponse: null,
  loading: false,
  error: null,
};

const medicalPaCoveragerawResponseSlice = createSlice({
  name: "medicalPaCoveragerawResponse",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      state.medicalPaCoveragerawResponse = null;
    },

    setMedicalPaCoveragerawResponse: (
      state,
      action: PayloadAction<any | null>,
    ) => {
      state.medicalPaCoveragerawResponse = action.payload;
      state.loading = false;
      state.error = null;
    },

    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setMedicalPaCoveragerawResponse, setLoading, setError } =
  medicalPaCoveragerawResponseSlice.actions;

export const getMedicalPaCoveragerawResponse =
  (orderId: string) => async (dispatch: AppDispatch) => {
    if (!orderId) {
      dispatch(setError("Order ID is required"));
      return;
    }

    try {
      dispatch(setLoading(true));

      const fullPath =
        FirestoreCollectionReference.medicalPaOrdersCoverage(orderId);

      const response = await FirestoreService.getAllDocuments(fullPath);

      dispatch(setMedicalPaCoveragerawResponse(response));
    } catch (error) {
      console.error("Error fetching medical PA coverage:", error);

      dispatch(
        setError(
          error instanceof Error ? error.message : "An unknown error occurred",
        ),
      );
    }
  };

export default medicalPaCoveragerawResponseSlice.reducer;
